import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import {
  stockReceiptApi,
  type CreateBatchRequest,
} from "../services/stockReceiptApi";

export const useCreateBatch = () => {
  return useMutation({
    mutationFn: (payload: CreateBatchRequest) =>
      stockReceiptApi.createBatch(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["inputs"] });
    },
  });
};

export const useCreateBulkBatches = () => {
  return useMutation({
    mutationFn: (payloads: CreateBatchRequest[]) =>
      stockReceiptApi.createBulkBatches(payloads),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["inputs"] });
    },
  });
};

export const useCreateBatchesWithReceipts = () => {
  return useMutation({
    mutationFn: (data: {
      lines: { batch: CreateBatchRequest; unit: string }[];
      movementDate: string;
      notes: string;
    }) =>
      stockReceiptApi.createBatchesWithReceipts(data.lines, {
        movementDate: data.movementDate,
        notes: data.notes,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["inputs"] });
    },
  });
};
